<div class="simple-global-search-actions" [uiVisible]="shouldShowPopover" [uiContent]="resultTemplate" [uiTrigger]="null" ui-popover uiOverlayClassName="without-arrow" uiPlacement="bottomLeft">
  <input
    class="search-field"
    id="search-input"
    #searchInput
    [(ngModel)]="searchTerm"
    [placeholder]="searchPlaceholder"
    (ngModelChange)="onSearchTermChange()"
    (keydown.arrowDown)="focusSearchItems()" />
</div>
<ng-template #resultTemplate>
  <div class="search-results" #resultsPopover>
    <ng-container *ngIf="!gettingSearchData">
      <search-results [maxItems]="9" (keydown.esc)="onEsc()" isSimpleSearch></search-results>
      <no-search-items-found isSimpleSearch></no-search-items-found>
    </ng-container>
    <ng-container *ngIf="!!gettingSearchData">
      <div class="skeleton">
        <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 1 }"></ui-skeleton>
        <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 3 }"></ui-skeleton>
        <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 2 }"></ui-skeleton>
      </div>
    </ng-container>
  </div>
</ng-template>
